// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"Panel_paginationPageDropdownWrap__Js7oW","container":"Panel_container__d0Jou"};